import { motion } from "framer-motion";
import SceneShell from "../components/SceneShell";

/**
 * Scene 38 — Section 6 maths opener.
 * "Let's do some really rough maths…"
 */

export default function Scene38_RoughMaths() {
  return (
    <SceneShell variant="ink" align="left" data-testid="scene-rough-maths">
      <motion.div
        className="absolute inset-0 pointer-events-none"
        animate={{
          background: [
            "radial-gradient(ellipse at 30% 50%, rgba(212,148,10,0.10) 0%, transparent 55%)",
            "radial-gradient(ellipse at 70% 50%, rgba(233,168,32,0.18) 0%, transparent 55%)",
            "radial-gradient(ellipse at 30% 50%, rgba(212,148,10,0.10) 0%, transparent 55%)",
          ],
        }}
        transition={{ duration: 12, repeat: Infinity, ease: "easeInOut" }}
      />

      <div className="relative max-w-[1500px] mx-auto w-full">
        <motion.h2
          initial={{ opacity: 0, y: 24, filter: "blur(8px)" }}
          animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          transition={{ duration: 1.2, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
          className="kn-display text-5xl sm:text-7xl lg:text-[110px] text-white leading-[0.95]"
          data-testid="rough-maths-title"
        >
          Let's do some
          <br />
          <span
            style={{
              background:
                "linear-gradient(135deg, #d4940a 0%, #e9a820 50%, #d4940a 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
              textShadow: "0 0 80px rgba(233,168,32,0.30)",
            }}
          >
            really rough maths…
          </span>
        </motion.h2>
      </div>
    </SceneShell>
  );
}
